import CanadaFlag from "./CanadaFlag";

const SLICES = 34;
const FLAG_W = 68;
const FLAG_H = 34;
const SLICE_W = FLAG_W / SLICES;
// Adjacent slices overlap slightly so sub-pixel seams between the
// vertical strips are invisible while the wave runs.
const OVERLAP = 0.7;

/**
 * Canadian flag perched on the upper-left of the hero image. The cloth
 * is cut into vertical slices; on hover each slice oscillates with a
 * phase offset and an amplitude that grows toward the free (fly) edge,
 * so a wave visibly travels across the fabric like real cloth — the
 * hoist edge stays nearly still. Clicks bubble up to the hero image's
 * /shop link.
 */
export default function HeroWavingFlag() {
  return (
    <span
      data-testid="hero-canada-flag"
      aria-label="Proudly Canadian"
      title="Proudly Canadian"
      className="hero-flag relative inline-flex items-center cursor-pointer"
      style={{ filter: "drop-shadow(0 3px 6px rgba(0,0,0,0.55))" }}
    >
      <span
        className="hero-flag-cloth flex"
        style={{ width: FLAG_W, height: FLAG_H }}
      >
        {Array.from({ length: SLICES }).map((_, i) => (
          <span
            key={i}
            className="hero-flag-slice block h-full overflow-hidden"
            style={{
              width: SLICE_W + (i < SLICES - 1 ? OVERLAP : 0),
              marginLeft: i ? -OVERLAP : 0,
              // Wave amplitude ramps up toward the fly edge; the phase
              // delay makes the crest travel left → right.
              "--amp": (0.5 + 4.0 * (i / (SLICES - 1))).toFixed(2),
              animationDelay: `${(-(i / SLICES) * 1.6).toFixed(3)}s`,
            }}
          >
            <span
              className="block"
              style={{ width: FLAG_W, marginLeft: -i * SLICE_W }}
            >
              <CanadaFlag size={FLAG_W} />
            </span>
          </span>
        ))}
      </span>
    </span>
  );
}
